import React from "react";
import "./CheckboxInput.scss";
import DOMPurify from "dompurify";

const CheckboxInput_old = ({
  input,
  meta,
  schemaProps: {
    machine_name,
    choice,
    value,
    checked,
    disabled,
    label,
    clearSchema,
  },
  disabledViaReuse,
  ...rest
}) => {
  if (input?.name?.includes("add_values_field[0]"))
    machine_name = `add_values_field[0]${machine_name}`;
  let ac_label = `${choice}`;
  let _checked = checked ? true : false;
  if (
    rest.formApi &&
    machine_name &&
    rest.formApi.getFieldState(machine_name)
  ) {
    if (
      rest.formApi.getFieldState(machine_name).value !== undefined &&
      rest.formApi.getFieldState(machine_name).value !== null &&
      typeof rest.formApi.getFieldState(machine_name).value !== "object"
    ) {
      let new_value = [];
      new_value[0] = rest.formApi.getFieldState(machine_name).value;
      rest.formApi.change(machine_name, new_value);
    } else if (
      rest.formApi.getFieldState(machine_name).value !== undefined &&
      rest.formApi.getFieldState(machine_name).value !== null &&
      rest?.formValues?.eta_790_c1_clearance_order_type === "790A" &&
      typeof rest.formApi.getFieldState(machine_name).value === "object"
    ) {
      rest.formApi.change(
        machine_name,
        rest?.formApi?.getFieldState(machine_name)?.value
      );
    } else if (
      /**
       * This elif is for Profiles - Worker Housing specifically as it is the only one with checkboxes -
       * as unchecking an option seems to turn the value into an empty array
       */
      machine_name.includes("new_profile") &&
      rest.formApi.getFieldState(machine_name).value !== undefined &&
      rest.formApi.getFieldState(machine_name).value !== null &&
      Array.isArray(rest.formApi.getFieldState(machine_name).value) &&
      rest.formApi.getFieldState(machine_name)?.value?.length === 0
    ) {
      rest.formApi.change(machine_name, undefined);
    }
    if (
      rest.formApi.getFieldState(machine_name).value &&
      Array.isArray(rest.formApi.getFieldState(machine_name).value) &&
      rest.formApi.getFieldState(machine_name).value.includes("YES")
    ) {
      _checked = true;
    }
  }
  // clearing schema based on check
  let clearFields = () => {
    clearSchema.forEach((c) => {
      // set to undefined to remove actual field from payload
      // set to null to keep field but have the value be a null type
      rest.formApi.change(c, null);
    });
  };
  const handleChange = (e) => {
    input.onChange(e);
    clearSchema && clearFields();
  };
  return (
    <div className="usa-checkbox">
      <input
        key={label}
        {...input}
        onChange={handleChange}
        name={machine_name}
        id={ac_label}
        checked={_checked}
        disabled={!!disabledViaReuse}
        className="usa-checkbox__input"
        type="checkbox"
      />
      <label className="usa-checkbox__label" htmlFor={ac_label}>
        <span
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(choice) }}
        />
      </label>
    </div>
  );
};

export default CheckboxInput_old;
